import React, { useState, useEffect } from 'react';
import {
  ActionBarMasterElementsComp,
  DatatableMasterElements,
  ImportMasterElements,
} from '../../components';
import Modal from 'react-bootstrap/Modal';
import axios from '../../library/axios';
import { MySwal } from '../../library/swal';
import { useLocation } from 'react-router-dom';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const MasterElementsPage = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [lgShowImport, setLgShowImport] = useState(false);

  const fetchData = async () => {
    try {
      const options = {
        url: `/elements/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setDatas(data);
      setFilterData(data);
    } catch (err) {
      notifyApiLoadError(err, 'pages/master-elements/index.fetchData');
    }
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/master-elements/index.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchData();
    fetchLoginStatus();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    const result = datas.filter((item) => {
      let Nomor = item.Nomor;
      let Deskripsi = item.Deskripsi;
      return Nomor.concat(Deskripsi)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterData(result);
    // eslint-disable-next-line
  }, [search]);

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Halaman Master Elemen Akreditasi
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            <ActionBarMasterElementsComp
              showFormImport={() => setLgShowImport(true)}
            />
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <DatatableMasterElements
                      datas={filterData}
                      search={search}
                      handleChangeSearch={handleChangeSearch}
                    />
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowImport}
        onHide={() => setLgShowImport(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Import Element Akreditasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ImportMasterElements
            close={() => setLgShowImport(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MasterElementsPage;
